import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import Button from "sushiweb/Button";
import Repeat from "sushiweb/Icons/all/Repeat";
import { bindActionCreators } from "redux";
import * as LevelActions from "../../../store/actions/Level";
import JSONInput from "react-json-editor-ajrm";
import locale from "react-json-editor-ajrm/locale/en";
import black from "sushiweb/tokens/color/black";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  button: {
    marginTop: "1.25rem",
    margin: theme.spacing(1),
    className: "shushi-btn",
    width: "12.5rem",
    height: "2.75rem",
  },
  levelView: {
    border: "0.063rem solid grey",
    borderRadius: "0.625rem",
    display: "flex",
  },
  levelDataView: {
    marginLeft: "0.625rem",
    marginRight: "0.313rem",
    marginBottom: "0.625rem",
    marginTop: "0.625rem",
    width: "50%",
  },
  levelOrderView: {
    marginLeft: "0.313rem",
    marginRight: "0.625rem",
    marginBottom: "0.625rem",
    marginTop: "0.625rem",
    width: "50%",
  },
  headingTab: {
    backgroundColor: "#B5B5B5",
    border: "0.063rem solid grey",
    borderRadius: "0.625rem",
  },
  fieldMargin: {
    marginTop: "0.625rem",
  },
}));

const getFieldValue = (level, key) => {
  switch (key) {
    case "description":
      var val = "";
      if (level[key]) {
        val = JSON.stringify(level[key]);
      }
      return <p>{val}</p>;
    default:
      var val = "";
      if (level) {
        val = JSON.stringify(level);
      }
      return typeof level == "object" ? (
        <JSONInput
          id={String(key)}
          placeholder={level}
          locale={locale}
          height="auto"
          width="auto  "
          viewOnly={true}
          colors={{
            colon: "#2781E7",
            string: "#FA7921",
            number: "#4B9B42",
            background: "#00000000",
            keys: "#1E1E1E",
            default: black,
          }}
          confirmGood={false}
        />
      ) : (
        val
      );
  }
};

const Level = (props) => {
  const classes = useStyles();
  const { level, activeOrder, levelName } = props;

  const handleClear = () => {
    props.resetState({ state: "level" });
    props.resetState({ state: "order" });
    props.resetState({ state: "levelName" });
  };

  return (
    <div class="Level" style={{ marginTop: "3.125rem" }}>
      <div
        ref={(el) => {
          if (!el) {
            return;
          }
          el.scrollIntoView();
        }}
        style={{
          marginTop: "3.125rem",
          marginBottom: "1.25rem",
          display: "flex",
        }}
      >
        <div style={{ width: "20%" }}>
          <Button
            className={classes.button}
            size="compressed"
            onClick={handleClear}
            icon={<Repeat />}
          >
            Clear
          </Button>
        </div>
        <div style={{ width: "80%", marginRight: "12.5rem" }}>
          <h1 style={{ textAlign: "center" }}>Simulation Result</h1>
        </div>
      </div>
      <div class="Level-View" className={classes.levelView}>
        <div class="Level-Data-View" className={classes.levelDataView}>
          <div className={classes.headingTab}>
            <h3 style={{ textAlign: "center" }}>Order Parameters</h3>
          </div>
          <div className={classes.fieldMargin}>
            {getFieldValue(activeOrder, "order")}
          </div>
        </div>
        <div class="Level-Order-View" className={classes.levelOrderView}>
          <div className={classes.headingTab}>
            <h3 style={{ textAlign: "center" }}>Selected Level</h3>
          </div>
          <div className={classes.fieldMargin}>
            <h3 style={{ textAlign: "center", color: "green" }}>{levelName}</h3>
            <p>{getFieldValue(level, "level")} </p>
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  const { Level } = state;
  return {
    level: Level.level,
    activeOrder: Level.order,
    levelName: Level.levelName,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getLevel: bindActionCreators(LevelActions.getLevel, dispatch),
    resetState: bindActionCreators(LevelActions.resetState, dispatch),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Level);
